import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "form--nested" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col-11" };
const _hoisted_4 = { class: "col-1" };
const _hoisted_5 = { class: "form__collection-item-button" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "form__collection-buttons" };
import { computed } from "vue";
import Icon from "../Icon.vue";
import FormFields from "./FormFields.vue";
import { collectionItemPrefix, fieldPath } from "./fieldControls";
import { useFieldControl } from "./useFieldControl";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlForm',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {},
        fieldPrefix: {},
        submitted: { type: Boolean }
    },
    emits: [
        'change',
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const { fieldOptions, emitChange } = useFieldControl(props, emit, 'FieldControlForm');
        const innerFieldPrefix = computed(() => fieldPath(props.fieldPrefix, props.field.name));
        const addRemove = computed(() => !fieldOptions.value.disabled && fieldOptions.value.collectionAddRemove !== false);
        // a collection is edited in place: the items are the data array itself
        const items = computed(() => (fieldOptions.value.collection && Array.isArray(props.data)) ? props.data : []);
        function onChange() {
            emitChange(props.data);
        }
        function removeCollectionItem(index) {
            if (!fieldOptions.value.collection) {
                return;
            }
            // no validation cleanup needed: the rows re-validate their new items and
            //   the field set of the last row removes its keys when it unmounts
            items.value.splice(index, 1);
            onChange();
        }
        function createCollectionItem() {
            if (!fieldOptions.value.collection) {
                return;
            }
            items.value.push({});
            onChange();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!_unref(fieldOptions).collection)
                    ? (_openBlock(), _createBlock(FormFields, {
                        key: 0,
                        form: __props.form,
                        fields: __props.field.fields ?? [],
                        "field-prefix": innerFieldPrefix.value,
                        data: __props.data,
                        disabled: _unref(fieldOptions).disabled ?? undefined,
                        validation: __props.validation,
                        submitted: __props.submitted,
                        onChange: onChange
                    }, null, 8, ["form", "fields", "field-prefix", "data", "disabled", "validation", "submitted"]))
                    : _createCommentVNode("", true),
                _cache[5] || (_cache[5] = _createTextVNode()),
                (_unref(fieldOptions).collection)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "form--nested form--nested-collection"
                            }, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        (_unref(fieldOptions).componentBeforeCollectionItem)
                                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(fieldOptions).componentBeforeCollectionItem), {
                                                key: 0,
                                                item: item,
                                                field: __props.field,
                                                form: __props.form,
                                                validation: __props.validation,
                                                params: _unref(fieldOptions).params,
                                                submitted: __props.submitted
                                            }, null, 8, ["item", "field", "form", "validation", "params", "submitted"]))
                                            : _createCommentVNode("", true),
                                        _cache[1] || (_cache[1] = _createTextVNode()),
                                        _createVNode(FormFields, {
                                            form: __props.form,
                                            fields: __props.field.fields ?? [],
                                            "field-prefix": _unref(collectionItemPrefix)(innerFieldPrefix.value, index),
                                            data: item,
                                            disabled: _unref(fieldOptions).disabled ?? undefined,
                                            validation: __props.validation,
                                            submitted: __props.submitted,
                                            onChange: onChange
                                        }, null, 8, ["form", "fields", "field-prefix", "data", "disabled", "validation", "submitted"]),
                                        _cache[2] || (_cache[2] = _createTextVNode()),
                                        (_unref(fieldOptions).componentAfterCollectionItem)
                                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(fieldOptions).componentAfterCollectionItem), {
                                                key: 1,
                                                item: item,
                                                field: __props.field,
                                                form: __props.form,
                                                validation: __props.validation,
                                                params: _unref(fieldOptions).params,
                                                submitted: __props.submitted
                                            }, null, 8, ["item", "field", "form", "validation", "params", "submitted"]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _cache[3] || (_cache[3] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("div", _hoisted_5, [
                                            (addRemove.value)
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 0,
                                                    onClick: _withModifiers(($event) => (removeCollectionItem(index)), ["prevent"]),
                                                    class: "button button--small",
                                                    href: ""
                                                }, [
                                                    _createVNode(Icon, { name: "trash-alt" })
                                                ], 8, _hoisted_6))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ])
                            ]));
                        }), 128)),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_7, [
                            (addRemove.value)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (createCollectionItem()), ["prevent"])),
                                    class: "button button--small",
                                    href: ""
                                }, [
                                    _createVNode(Icon, { name: "plus" })
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ], 64))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
